"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PostpaidAccessoryModal_1 = require("./PostpaidAccessoryModal");
exports.default = PostpaidAccessoryModal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/PostpaidAccessoryModal/index.js
// module id = 2361
// module chunks = 8